import React, { useCallback } from 'react'

import {
  Box,
  Text,
  Display,
  JustifyContent,
  FontWeight,
  Space,
  Icon,
  IconVariant,
  Color,
  AlignItems,
  withCitrusTheme,
  Link,
} from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'
import { browserHistory } from 'react-router'

import { setTempDeliveryOptions } from 'actions/deliveries'
import routes from 'config/routes'

interface Props {
  portionsCount: string
  orderId?: string
  orderDeliveryDate?: string
}

const LinkWithoutUnderline = withCitrusTheme(Link, () => ({
  textDecoration: 'none',
  boxShadow: 'none',
}))

export const OrderBoxSize = ({ portionsCount, orderId, orderDeliveryDate }: Props) => {
  const dispatch = useDispatch()
  const onCTAClick = useCallback(() => {
    const deliveryDate = orderDeliveryDate?.slice(0, 10)

    if (deliveryDate) {
      dispatch(setTempDeliveryOptions(deliveryDate, orderId))
    }
    browserHistory.push(`${routes.client.deliveryDetails}`)
  }, [dispatch, orderDeliveryDate, orderId])

  return (
    <div data-testing="orderBoxSize">
      <Box display={Display.Flex} justifyContent={JustifyContent.SpaceBetween}>
        <Text fontWeight={FontWeight.Bold}>{`${portionsCount} person box`}</Text>
        <Box display={Display.Flex} alignItems={AlignItems.Center} onClick={onCTAClick}>
          <LinkWithoutUnderline>
            <Text size={1} color={Color.Secondary_400}>
              Edit
            </Text>
          </LinkWithoutUnderline>
          <Space size={1} direction="horizontal" />
          <Icon name="edit" variant={IconVariant.Actionable} size={5} />
        </Box>
      </Box>
    </div>
  )
}
